import { throttle } from './utils';

const MAIN_LIST_SELECTOR = '.navigation > ul';
const AUXILARY_LIST_SELECTOR = '.navigation__auxilary-container ul';

const getMainList = (): HTMLElement =>
  document.querySelector(MAIN_LIST_SELECTOR);

const getAuxilaryList = (): HTMLElement =>
  document.querySelector(AUXILARY_LIST_SELECTOR);

function isMainListOverflowing() {
  const mainList = getMainList();
  const firstItem = mainList.firstElementChild as HTMLElement;
  return mainList.scrollHeight > firstItem.offsetHeight;
}

function toggleItemsVisibility() {
  const mainList = getMainList();
  const auxilaryList = getAuxilaryList();

  if (!mainList || !auxilaryList) {
    return;
  }

  const mainListItems = mainList.children;
  const auxilaryListItems = auxilaryList.children;

  for (let i = 0; i < mainListItems.length; i++) {
    mainListItems[i].classList.remove('hidden');
    auxilaryListItems[i].classList.add('hidden');
  }

  let count = 0;
  for (let i = mainListItems.length - 1; i >= 0; i--) {
    if (isMainListOverflowing()) {
      mainListItems[i].classList.add('hidden');
      auxilaryListItems[i].classList.remove('hidden');
      count++;
    }
  }
}

export function setupPrimaryNavigation() {
  toggleItemsVisibility();
  const throttledToggleItemsVisibility = throttle(toggleItemsVisibility, 200);
  window.addEventListener('resize', throttledToggleItemsVisibility);
}